import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';

@Pipe({
  name: 'searchfilter'
})
@Injectable()
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    if (items) {
      if (!value || value.length <= 1) {
        return items;
      } else {
        return items.filter((it) => {
          return it[field].indexOf(value) > -1;
        });
      }
    } else {
      return [];
    }
  }
}
